//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import $$ from 'jquery'
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
import Footer from '../footer/footer.vue'
import Header from '../header/header.vue'
import {requestByPost} from '@/util/request'
import {API} from '@/util/api'
export default {
 name: 'caseDetail',
 data(){
  let that = this
  return {
    windowScreenWidth:window.screen.width,
    societyId: (this.$route.query.societyId != null && this.$route.query.societyId != '' ) ? this.$route.query.societyId : this.$store.getters['home/getCommonSocietyId'],//0显示平台头部按钮  1显示机构头部按钮,  //机构id
    societyName: (this.$route.query.societyName != null && this.$route.query.societyName != '' ) ? this.$route.query.societyName : this.$store.getters['home/getCommonSocietyName'],//0显示平台头部按钮  1显示机构头部按钮,  //机构id
    logoImgUrl: (this.$route.query.logoImgUrl != undefined && this.$route.query.logoImgUrl != null && this.$route.query.logoImgUrl != '' ) ? this.$route.query.logoImgUrl : this.$store.getters['home/getSocietyLogoUrl'],
    showD:false,
    value:'',
    active:1,//1产品方案结束    3方案成品展示
    showImall:false,//显示方案成品展示图轮播图
    projectId: "",//父页面传入参数，方案id
    ccProjectInfoBo: {},//查询出来的方案信息
    checkCpzsType: "全部",//成品展示选中的是哪个分类选项
    checkCpzs: null,//成品展示选中的分类对象（含该分类下所有图片信息）
    inType: (this.$route.query.inType != null && this.$route.query.inType != '' ) ? this.$route.query.inType : 0,//从哪儿进来的   0公司主页点击案例进入/首页点击案例进入    1搜索页点击案例进入  2机构首页进入    3需求页进入
    //方案头部轮播图
    swiperOptionTop: {
      loop: false,
      loopedSlides: 3,
      spaceBetween: 10,
      touchRatio: 0,
    },
    swiperOptionThumbs: {
      loop: false,
      loopedSlides: 1,
      spaceBetween: 10,
      centeredSlides: false,
      slidesPerView: 3,
      touchRatio: .0,
      slideToClickedSlide: false,
      freeMode: false,
      mousewheel: false,
    },
    //方案成品展示 轮播图
    swiperOptionTopF: {
      loop: false,
      loopedSlides: 3,
      spaceBetween: 10,
      touchRatio: 0.2,
    },
    swiperOptionThumbsF: {
          loop: false,
          loopedSlides: 5,
          spaceBetween: 10,
          centeredSlides: true,
          slidesPerView: 'auto',
          touchRatio: 0.2,
          slideToClickedSlide: true,
          on: {
          tap(event) {
            that.swiperF.slideTo(event.activeIndex, 1000, false)
          },
        },
      },


    }
 },
 components:{
    Swiper,
    SwiperSlide,
    Header,
    Footer,
 },
  directives: {
    swiper: directive
  },
 computed:{
    swiper() {
      return this.$refs.swiperTop.$swiper
    },
 },
  methods:{
    showDel(){
      this.showD = !this.showD
    },
    showSwip(){
      this.showImall = true
    },
    close(e){
      if(e.toElement.nodeName =="DIV") this.showImall = false
    },
    //1产品方案结束    3方案成品展示
    addC(params){
      this.active = params
    },
    //初始化方案信息
    fnInitProjectInfo(){
      let that = this;
      let selObj = new Object();
      selObj.id = that.projectId;
      requestByPost(API.getProjectInfoById,JSON.stringify(selObj)).then((res)=>{
        that.ccProjectInfoBo = res.data.obj;
        res.data.obj.ccProjectProdShowList.forEach((item, index) => {
          if(index == 0){
            that.checkCpzs = item;
          }
        })
        //根据当前登录的用户id 和 companyId 查询当前客户是否已经生成了改企业的客户信息，生成了不做处理，未生成，创建游客
        that.fnCheckCustInfoByCompanyIdAndUserId();

      })
    },
    //跳转到AI智能报价页面
    fnGotoAiznbjPage(){
      var schemeInfo = {
        saasProjectId: this.ccProjectInfoBo.saasProjectId, // 对应saas的方案id
        saasFactoryId: this.ccProjectInfoBo.saasFactoryId,// 对应saas的工厂id
        projectId: this.ccProjectInfoBo.id,// 平台方案id
        ccProdTypeId: this.ccProjectInfoBo.ccProdTypeId,//分类id
        ccProdTypeName: this.ccProjectInfoBo.prodTypeName,//分类name
        projectName: this.ccProjectInfoBo.name,
        companyName: this.ccProjectInfoBo.companyName,
        companyId: this.ccProjectInfoBo.companyId
      }
      // if(this.fnCheckLogin()){
      localStorage.setItem("schemeInfo", JSON.stringify(schemeInfo));
      this.$router.push({path: '/cdrConvert', name: 'AI报价', params: {'schemeInfo': JSON.stringify(schemeInfo)}});
      // }else{
      //   this.$router.push({path: '/login', query: {redirect_uri:'/cdrConvert',state: JSON.stringify(schemeInfo),inType:1}});
      // }
    },
    //根据当前登录的用户id 和 companyId 查询当前客户是否已经生成了改企业的客户信息，生成了不做处理，未生成，创建游客
    fnCheckCustInfoByCompanyIdAndUserId(){
      let that = this;
      var userInfo=this.$store.getters.getUserInfo
      if(userInfo!=null && userInfo.id!=null){
        let userId = userInfo.id;
        let obj = new Object();
        obj.userId = userId;
        obj.companyId = that.ccProjectInfoBo.companyId;
        obj.inTypeText = "案例'"+that.ccProjectInfoBo.name+"'进入";//进入方式文本描述，存到客户备注中： ***案例进入；
        requestByPost(API.queryByUserIdAndCompanyId,JSON.stringify(obj)).then((res)=>{
          // alert(1);
        })
      }else{
        that.isFollow = 0;
      }

    },
    //跳转到平台首页
    fnGoToHomePage(e){
       this.fnStopBub(e);
       this.$router.push({path: '/home'});
    },
    //跳转到企业发布信息详情页
    fnGotoCompanyDetail(id,companyName,e){
      this.fnStopBub(e);
      this.$router.push({path: '/companyDetailNew', query: {companyId:id,inType:1}});
      
    },
    //跳转到找合作页
    fnGotoSearchPage(e){
       this.fnStopBub(e);
       this.$router.push({path: '/search', query: {selType:1}});
    },
    fnGotoDemandPage(e){
      this.fnStopBub(e);
       this.$router.push({path: '/demand', query: {selType:1}});
    },
    //切换成品展示选项页
    showCpzsTypeTab(params,e){
      this.fnStopBub(e);
      this.checkCpzsType = params;
      this.ccProjectInfoBo.ccProjectProdShowList.forEach((item, index) => {
			  if(item.title == params){
          this.checkCpzs = this.ccProjectInfoBo.ccProjectProdShowList[index];
        }
      })
    },
    //跳转到机构主页
    fnGoToSocietyIndexPage(e){
      this.fnStopBub(e);
      this.$router.push({path: '/societyIndex', query: {societyId:this.societyId,societyName:this.societyName,logoImgUrl:this.logoImgUrl}});
    },
  },
  mounted(){
    document.title = "方案详情"
  },
  created(){
    this.$store.commit('home/setMenuActive', -1);
    var projectId = this.$route.query.projectId;
    if(!_.isEmpty(projectId)){
      this.projectId = projectId;
    }
    //初始方案信息
    this.fnInitProjectInfo();

  },
  updated(){
    //每个图片加载完都
    $$(".autoHeight").each(function(){
      let widthNum = $$(this).width();
      $$(this).height(widthNum*9/16);
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/case/CaseDetail.vue